<!-- <ng-container *ngIf="refundModalSuccess">
  <div class="success-icon d-flex align-items-center justify-content-center">
    <i class="fas fa-check-circle"></i>
  </div>
  <p class="text-muted text-center mt-3 f-w-5">
    A refund of
    <span style="color: #d50000"
      >{{ currency }}{{ globalAmount | number: "1.2-2" }}</span
    >
    will be applied to the original payment method for the order
  </p>
</ng-container> -->

<!-- <ng-container *ngIf="refundModalLoader">
  <div class="spinner-border text-pink my-2"></div>
  <h3>Refund Processing...</h3>
  <p class="text-lighter text-center">
    Your refund request is currently being processed. Please wait...
  </p>
</ng-container> -->

<div *ngIf="refundModalSuccess">

  <div class="success-icon d-flex align-items-center justify-content-center">
    <img src="../../../../../assets/images/sucess-icon.png" alt="">
  </div>
  <h3 class="refund-text" *ngIf="!customRefundedS">{{ "Refund Successful" | translate | async }}</h3>
  <h3 class="refund-text" *ngIf="customRefundedS"> {{ "Custom Refund Successful" | translate | async }}</h3>
  <p class="fw-500 mb-4 p-text">
    {{ "A refund of" | translate | async }}
    <!-- {{ currency }}{{ globalAmount | number: "1.2-2" }} -->
    <span style="color: #d50000">{{ currency }}{{ globalAmount | number: "1.2-2" }}</span>
    {{ "will be applied to the original payment method for the order" | translate | async }}
  </p>
</div>

<div *ngIf="voidModalSuccess">

  <div class="success-icon d-flex align-items-center justify-content-center">
    <img src="../../../../../assets/images/sucess-icon.png" alt="">
  </div>
  <h3 class="refund-text">{{ "Void Successful" | translate | async }}</h3>
  <p class="fw-500 mb-4 p-text">
    {{ "A Void of" | translate | async }}
    <span style="color: #d50000">{{ currency }}{{ globalAmount | number: "1.2-2" }}</span>
    {{ "will be applied to the original payment method for the order" | translate | async }}
  </p>
</div>

<div class="refund-processing" *ngIf="refundModalLoader">
  <div class="spinner-border color-red mb-4" role="status">
    <span class="sr-only">{{ "Loading..." | translate | async }}</span>
  </div>
  <div class="refund-text f-24 fw-600 mb-3">{{ "Refund Processing..." | translate | async }}</div>
  <p class="fw-500 mb-4 p-text">
    {{ "Your refund request is currently being processed. Please wait..." | translate | async }}
  </p>
</div>

<div class="refund-processing" *ngIf="voidModalLoader">
  <div class="spinner-border color-red mb-4" role="status">
    <span class="sr-only">{{ "Loading..." | translate | async }}</span>
  </div>
  <div class="refund-text f-24 fw-600 mb-3">{{ "Void Processing..." | translate | async }}</div>
  <p class="fw-500 mb-4 p-text">
    {{ "Your Void request is currently being processed. Please wait..." | translate | async }}
  </p>
</div>